<template>
  <div class="headerMobile">
    <div
      class="headerMobile_wrapper"
      :class="{
        '-withoutPoints': !showPoints
      }"
      data-cy="headerMobile"
      @keyup.esc="onHandlerEsc"
      tabindex="0"
    >
      <div v-if="showBack" class="headerMobile_col -back" @click="goBack">
        <div class="headerMobile_back">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_3978_3062)">
              <path d="M10.828 12.0007L15.071 16.2437C15.4615 16.6342 15.4615 17.2673 15.071 17.6577C14.6805 18.0482 14.0475 18.0482 13.657 17.6577L8.70711 12.7078C8.31658 12.3173 8.31658 11.6841 8.70711 11.2936L13.657 6.34372C14.0475 5.95325 14.6805 5.95325 15.071 6.34372C15.4615 6.73418 15.4615 7.36725 15.071 7.75772L10.828 12.0007Z" fill="#B4B8BB"/>
            </g>
            <defs>
              <clipPath id="clip0_3978_3062">
                <rect width="24" height="24" fill="white"/>
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>

      <div class="headerMobile_col -name">
        <img v-if="avatar" class="headerMobile_avatar" :src="avatar" :alt="title">
        <div class="headerMobile_col -title">
          <div class="headerMobile_title">
            {{ title }}
          </div>
          <router-link v-if="showPoints" class="headerMobile_points" :to="{ name: 'points' }">
            <ac-points-label class="-enabled" :points="userScoreAmount"/>
          </router-link>
        </div>
      </div>

      <slot name="menu">
        <div class="headerMobile_col -nav">
          <button
            v-if="isSearchVisible"
            class="headerMobile_searchTrigger"
            data-test="header-search-trigger"
            type="button"
            aria-label="Поиск"
            @click="isSearchOpen = true"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_25141_42824)">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.421 10.6749C17.421 11.5613 17.2464 12.4391 16.9072 13.258C16.568 14.077 16.0708 14.8211 15.444 15.4479C14.8172 16.0747 14.073 16.5719 13.2541 16.9111C12.4352 17.2503 11.5574 17.4249 10.671 17.4249C9.78456 17.4249 8.90682 17.2503 8.08787 16.9111C7.26893 16.5719 6.52481 16.0747 5.89802 15.4479C5.27122 14.8211 4.77402 14.077 4.4348 13.258C4.09558 12.4391 3.92099 11.5613 3.92099 10.6749C3.92099 8.88468 4.63215 7.16779 5.89802 5.90192C7.16389 4.63605 8.88078 3.92489 10.671 3.92489C12.4612 3.92489 14.1781 4.63605 15.444 5.90192C16.7098 7.16779 17.421 8.88468 17.421 10.6749ZM16.191 17.7849C14.3826 19.1889 12.107 19.8509 9.82769 19.6361C7.54834 19.4214 5.43651 18.346 3.92211 16.629C2.40772 14.912 1.60461 12.6823 1.67629 10.394C1.74797 8.1057 2.68904 5.93071 4.30792 4.31182C5.9268 2.69294 8.10179 1.75187 10.3901 1.6802C12.6784 1.60852 14.9081 2.41163 16.6251 3.92602C18.3421 5.44041 19.4174 7.55224 19.6322 9.83159C19.8469 12.1109 19.185 14.3865 17.781 16.1949L21.966 20.3799C22.0765 20.4829 22.1652 20.6071 22.2267 20.7451C22.2881 20.8831 22.3212 21.0321 22.3239 21.1831C22.3265 21.3342 22.2988 21.4842 22.2422 21.6243C22.1856 21.7644 22.1014 21.8916 21.9945 21.9984C21.8877 22.1053 21.7605 22.1895 21.6204 22.2461C21.4803 22.3027 21.3303 22.3304 21.1792 22.3278C21.0281 22.3251 20.8792 22.2921 20.7412 22.2306C20.6032 22.1691 20.479 22.0804 20.376 21.9699L16.191 17.7849Z" fill="#203454"/>
              </g>
              <defs>
                <clipPath id="clip0_25141_42824">
                  <rect width="24" height="24" fill="white"/>
                </clipPath>
              </defs>
            </svg>
          </button>
          <template v-if="nav">
            <div @click="toggleMenu" class="headerMobile_menu">
              <div class="headerMobile_menu-wrapper">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_3976_44)">
                    <path d="M3 5C3 4.44772 3.44772 4 4 4H20C20.5523 4 21 4.44772 21 5C21 5.55228 20.5523 6 20 6H4C3.44772 6 3 5.55228 3 5ZM3 12C3 11.4477 3.44772 11 4 11H14C14.5523 11 15 11.4477 15 12C15 12.5523 14.5523 13 14 13H4C3.44772 13 3 12.5523 3 12ZM3 19C3 18.4477 3.44772 18 4 18H20C20.5523 18 21 18.4477 21 19C21 19.5523 20.5523 20 20 20H4C3.44772 20 3 19.5523 3 19Z" fill="#0E2242"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_3976_44">
                      <rect width="24" height="24" fill="white"/>
                    </clipPath>
                  </defs>
                </svg>
                <span
                  v-if="isShowMenuBange"
                  class="headerMobile_menuBadge"
                />
              </div>
            </div>
          </template>
        </div>
      </slot>
    </div>

    <nav-bar-mobile
      :model-value="showMenu"
      @update:model-value="onNavBarClose"
    />

    <search-overlay v-if="isSearchVisible" v-model="isSearchOpen" @submit="onSearchSubmit" />
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, ref, watch } from 'vue'
import { RouteLocationRaw, useRouter } from 'vue-router'
import NavBarMobile from '@web/platform.v3/components/menu/navBarMobile.vue'
import { useStore } from '@web/store'
import AcPointsLabel from '@web/components.v2/PointsLabel.vue'
import SearchOverlay from '@web/components.v2/Search/SearchOverlay.vue'
import { careChatEnabled, isSearchEnable } from '@web/common/ExternalConfig/getters'
import Analytics from '@web/services/Analytics/Analytics'
import useBackNavigation from '@web/composition/useBackNavigation'
import { useRemindersIndicator } from '@web/platform.v3/composables/useRemindersIndicator'
import { buildSearchLocation } from '@web/router/goToSearch'

export default defineComponent({
  name: 'HeaderMobile',
  props: {
    avatar: {
      type: String,
      default: ''
    },
    title: {
      title: String,
      default: ''
    },
    nav: {
      type: Boolean,
      default: true
    },
    customBack: {
      type: Boolean,
      default: false
    },
    back: {
      type: Boolean,
      default: false
    },
    prevPage: {
      type: [String, Object]
    },
    showPoints: {
      type: Boolean,
      default: false
    }
  },
  components: {
    AcPointsLabel,
    NavBarMobile,
    SearchOverlay
  },
  emits: ['goBack', 'menu:toggle', 'menu:open', 'menu:close', 'item:select'],
  setup (props, ctx) {
    const { isIndicatorVisible } = useRemindersIndicator()

    const isSearchOpen = ref(false)
    // Точки входа в поиск показываем только по флагу конфига (MOB-276).
    const isSearchVisible = computed(() => isSearchEnable())

    const showMenu = ref<boolean>(false)
    function openMenu () {
      showMenu.value = true
      ctx.emit('menu:open')
      Analytics.send({
        action: 'open_burger',
        project: 'platform'
      })
    }
    function closeMenu () {
      showMenu.value = false
      ctx.emit('menu:close')
      Analytics.send({
        action: 'close_burger',
        project: 'platform'
      })
    }
    function toggleMenu () {
      if (showMenu.value) {
        closeMenu()
      } else {
        openMenu()
      }
      ctx.emit('menu:toggle', showMenu.value)
    }

    const backNavigation = useBackNavigation()

    const router = useRouter()
    function onSearchSubmit (query: string): void {
      router.push(buildSearchLocation(query))
    }
    const showBack = computed(() => props.back || props.prevPage || props.customBack)
    function goBack () {
      if (showMenu.value) {
        closeMenu()
      } else if (props.customBack) {
        ctx.emit('goBack')
      } else {
        if (props.prevPage) {
          router.push(props.prevPage as RouteLocationRaw)
        } else {
          backNavigation.goBack()
        }
      }
    }

    const store = useStore()
    const menu = computed(() => store.getters['menu/mobile'])
    const userScoreAmount = computed(() => store.getters['userScore/amount'])
    const careChatUnread = computed<number>(() =>
      careChatEnabled() ? (store.getters['careChat/unreadCount'] || 0) : 0
    )
    const isShowMenuBange = computed(() => {
      return careChatUnread.value > 0 || isIndicatorVisible.value
    })

    function selectMenuItem (item) {
      ctx.emit('item:select', item)
      closeMenu()
    }

    function onHandlerEsc () {
      if (showMenu.value) {
        closeMenu()
      }
    }

    function onNavBarClose (value: boolean) {
      showMenu.value = value
      if (!value) {
        ctx.emit('menu:close')
        ctx.emit('menu:toggle', false)
      }
    }

    watch(showMenu, (value) => {
      document.body.style = value ? 'overflow: hidden; position: fixed; width: 100%;' : ''
    }, {
      immediate: true
    })

    return {
      isSearchVisible,
      showBack,
      goBack,
      menu,
      toggleMenu,
      showMenu,
      selectMenuItem,
      userScoreAmount,
      careChatUnread,
      onHandlerEsc,
      onNavBarClose,
      isShowMenuBange,
      isSearchOpen,
      onSearchSubmit
    }
  }
})
</script>

<style lang="scss">
@import '@web/assets/scss/vars.scss';

.headerMobile {
  width: 100%;

  &.-menuOpen {
    display: flex;
    flex-flow: column nowrap;
    width: 100%;
    min-height: 100%;
    overflow: auto;
    max-height: 100%;
  }

  &_wrapper {
    display: flex;
    height: 65px;
    background: var(--ac-color-white);
    width: 100vw;
    overflow: hidden;
    font-family: Inter, sans-serif;
    flex-shrink: 0;
    box-shadow: 0 5px 15px rgba(180, 184, 187, 0.35);
    position: relative;
    z-index: 1;
  }

  &_col {
    &.-back {
      flex-shrink: 0;
    }

    &.-name {
      display: flex;
      align-items: center;
      max-width: calc(100vw - 60px);
      width: 100%;
    }

    &.-title {
      display: flex;
      flex-flow: column nowrap;
      align-items: flex-start;
      justify-content: flex-start;
    }

    &.-nav {
      position: relative;
      display: flex;
      align-items: center;
      flex-shrink: 0;
      margin-left: auto;
      /* ширина считается по фактическому содержимому: одна кнопка (без бургера) или две (с бургером) */
      width: auto;
    }
  }

  &_wrapper.-withoutPoints .-name {
    justify-content: center;
  }

  &_wrapper.-withoutPoints &_title {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: var(--ac-color-black);
  }

  &_back {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60px;
    width: auto;
    padding-left: 20px;
    padding-right: 6px;
  }

  &_avatar {
    display: block;
    width: 36px;
    height: 36px;
    flex-shrink: 0;
    border-radius: 50%;
    margin: 10px 16px;
    overflow: hidden;
    object-fit: cover;
    object-position: center;
  }

  &_title {
    font-family: Inter, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
    color: var(--ac-color-black);

    &:only-child {
      width: 100%;
      text-align: center;
    }

    &:first-letter {
      text-transform: capitalize;
    }
  }

  &_points {
    display: block;
    max-width: 250px;
    margin-top: 6px;
    text-decoration: none;
  }

  &_searchTrigger {
    display: flex;
    height: 40px;
    width: 24px;
    // Зазор до бургера складывается из правого паддинга здесь и левого
    // паддинга бургера (16px) — сам бургер не трогаем, он общий для кабинета.
    padding: 10px 4px 10px 16px;
    justify-content: center;
    align-items: center;
    box-sizing: content-box;
    border: none;
    background: transparent;
    flex-shrink: 0;
    cursor: pointer;
  }

  &_menu {
    position: relative;
    display: flex;
    height: 40px;
    width: 24px;
    padding: 10px 16px;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    box-sizing: content-box;
    background: transparent;
    flex-shrink: 0;
    cursor: pointer;

    &-wrapper {
      position: relative;
      display: flex;
      height: 24px;
      width: 24px;
      justify-content: center;
      align-items: center;
    }
  }

  &_menuBadge {
    position: absolute;
    bottom: 1px;
    right: 1px;
    width: 10px;
    height: 10px;
    padding: 1px;
    border-radius: 50%;
    background-color: var(--ac-color-white);
    pointer-events: none;
    z-index: 2;

    &::after {
      content: '';
      display: block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: var(--ac-color-deep-liliac);
    }
  }

  &_menuContent {
    padding-top: 12px;
  }
}
</style>
